// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar__SearchBar-VRpPw","SearchBarInput":"SearchBar__SearchBarInput-fVXaF","for-white-bg":"SearchBar__for-white-bg-OUqkh","SearchHint":"SearchBar__SearchHint-LtZ_x"};